import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IExcel } from '../models/models'

export class GetCurrentAccountStatementToExcelApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'excel/getCurrentAccountStatementToExcel',
      requesterInfo,
    })
  }

  public async getCurrentAccountStatementToExcel(request: IExcel): Promise<any> {
    return await this.postAsync<any>(request)
  }
}
